import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { ArpioSharedModule } from '../shared/arpio-shared.module'
import { CreateAccountAuthComponent } from './components/create-account-auth/create-account-auth.component'
import { CreateAccountPanelShellComponent } from './components/create-account-panel-shell/create-account-panel-shell.component'
import { CreateAccountShellComponent } from './components/create-account-shell/create-account-shell.component'
import { CreateAccountRoutingModule } from './create-account-routing.module'

@NgModule({
  declarations: [CreateAccountShellComponent, CreateAccountAuthComponent, CreateAccountPanelShellComponent],
  imports: [CommonModule, CreateAccountRoutingModule, ReactiveFormsModule, ArpioSharedModule],
})
export class CreateAccountModule {}
